<template>
  <div style="width: 1200px; margin: 0 auto; border-radius: 25px">
    <Title
      :title="{ name: '人员管理', path: '/system/sysUser' }"
      :button-array="buttonArray"
      @openSaveOrEdit="openSaveOrEdit(1)"
    ></Title>
    <div style="margin: 10px auto">
      <el-card class="box-card">
        <el-row :gutter="20" style="margin-left: 10px">
          <el-col :span="6">
            <el-input placeholder="姓名" v-model="qparam.realName" />
          </el-col>
          <el-col :span="6">
            <el-input placeholder="岗位" v-model="qparam.job" />
          </el-col>
          <el-col :span="6">
            <el-button
              icon="el-icon-refresh-left"
              type="primary"
              @click="resetQparam"
              >重置</el-button
            >

            <el-button icon="el-icon-search" type="primary" @click="search"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-card>
    </div>
    <div style="margin: 10px auto">
      <el-card class="box-card" style="min-height: 650px">
        <el-table
          :data="userData"
          :header-cell-style="{
            background: 'rgb(245,245,245)',
            color: 'black',
          }"
          :cell-style="{ color: 'black' }"
        >
          <el-table-column prop="realName" label="姓名" />
          <el-table-column label="生日" prop="birthDay" />
          <el-table-column label="岗位" prop="job" />
          <el-table-column label="角色" prop="role" width="150">
            <template slot-scope="scope">
              <div style="display: flex; flex-wrap: wrap">
                <div v-for="item in roleList">
                  <el-tag
                    v-if="scope.row.roles.includes(item.roleId)"
                    type="info"
                    size="small"
                    style="margin: 1px"
                    >{{ item.roleName }}</el-tag
                  >
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="手机" prop="phone" />
          <el-table-column label="入职时间" prop="entryTime" />
          <el-table-column
            prop="isUse"
            align="center"
            label="启用状态"
            width="180"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.useBoolean"
                active-color="#13ce66"
                @change="
                  (val) => {
                    disableSysUser(val, scope.row.userId);
                  }
                "
                inactive-color="#ff4949"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            align="center"
            label="操作"
            width="120"
          >
            <template slot-scope="scope">
              <el-row>
                <el-col :span="12">
                  <el-button
                    type="text"
                    size="small"
                    STYLE="color: black;"
                    @click="openSaveOrEdit(2, scope.row)"
                    >编辑</el-button
                  >
                </el-col>
                <el-col
                  :span="12"
                  v-if="
                    scope.row.wxOpenId == undefined ||
                    scope.row.wxOpenId == null ||
                    scope.row.wxOpenId == ''
                  "
                >
                  <el-popover placement="right" width="400" trigger="click">
                    <el-image
                      :src="
                        apiServer +
                        'sysQrLogin/getWxBdQrImge?userId=' +
                        scope.row.userId
                      "
                    ></el-image>
                    <el-button
                      type="text"
                      size="small"
                      STYLE="color: #67C23A;"
                      slot="reference"
                      >微信绑定</el-button
                    >
                  </el-popover>
                </el-col>
                <el-col :span="12" v-else>
                  <el-popconfirm
                    title="确定解绑用户微信吗？"
                    @confirm="unbanding(scope.row.userId)"
                  >
                    <el-button
                      slot="reference"
                      type="text"
                      size="small"
                      STYLE="color: #F56C6C;"
                      >解绑微信</el-button
                    >
                  </el-popconfirm>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 40px auto; width: 30%">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="qparam.current"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="qparam.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :page-count="totlePages"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>

    <el-dialog
      :before-close="closeWindow"
      :title="dialogTitle"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="640px"
    >
      <UserEdit
        :user-form="userForm"
        @closeWindow="closeWindow"
        v-if="dialogVisible"
      ></UserEdit>
    </el-dialog>
  </div>
</template>

<script>
import Title from "../../Title";
import UserEdit from "./UserEdit";
import {AesDecrypt, apiServer} from "@/util";
import {
  requestGetAllSysUserTableList,
  requestDisableSysUser,
  requestUnbanding,
  requestRoleList, requestGetAnnualLeaveByUserId,
} from "@/api";
import {annualLeave} from "@/util/helper";

export default {
  name: "SysUser",
  components: { Title, UserEdit },
  data() {
    return {
      qparam: {
        realName: "",
        job: "",
        current: 1,
        size: 10,
      },
      userForm: {
        realName: "",
        phone: "",
        job: "",
        sex: 1,
        deptId: "",
        roleId: "",
        isUse: 1,
        birthDay: "",
        roles: [],
        userStatus: 1,
        requestLeaveAnnual: 0,
        remainLeaveAnnual: 0,
      },
      totalLeaveAnnual: 0, // 年假天数
      requestLeaveAnnual: 0, // 已请天数
      remainLeaveAnnual: 0, // 剩余天数
      totlePages: null, //总页数
      total: null, //总记录结果行数
      userData: [],
      dialogVisible: false,
      dialogTitle: "新增用户",
      buttonArray: [
        {
          type: "success",
          title: "新增用户",
          method: "openSaveOrEdit",
          disabled: false,
        },
      ],
      apiServer: apiServer,
      roleList: [],
      type: ["正式","试用"]
    };
  },
  methods: {
    handleSizeChange(size) {
      this.qparam.current = 1;
      this.qparam.size = size;
      this.getAllSysUser();
    },
    handleCurrentChange(num) {
      this.qparam.current = num;
      this.getAllSysUser();
    },
    async unbanding(userId) {
      let params = { userId: userId };
      const res = await requestUnbanding(params);
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.getAllSysUser();
      } else {
        this.$message.error(res.msg);
      }
    },
    async search() {
      this.qparam.current = 1;
      await this.getAllSysUser();
    },
    async getAllSysUser() {
      const response = await requestGetAllSysUserTableList(this.qparam);
      if (response.code == 200) {
        this.total = response.total;
        this.userData = response.rows;
      } else {
        this.$message.error(response.msg);
      }
    },
    async disableSysUser(isUse, userId) {
      let state = 2;
      if (isUse) state = 1;
      let param = { userId: userId, use: state };
      const response = await requestDisableSysUser(param);
      if (response.code == 200) {
        this.$message.success(response.msg);
      } else {
        this.$message.error(response.msg);
      }
    },
    async openSaveOrEdit(type, user) {
      this.dialogTitle = "新增用户";
      if (type == 2) {
        this.dialogTitle = "编辑用户";
        this.userForm = JSON.parse(JSON.stringify(user));
        this.totalLeaveAnnual = annualLeave(user.entryTime)
        await this.getAnnualLeave(user.userId);
        console.log('点击完编辑按钮后',this.userForm.remainLeaveAnnual,this.userForm.requestLeaveAnnual)
      }
      this.dialogVisible = true;
    },
    closeWindow() {
      this.dialogVisible = false;
      this.userForm = {
        realName: "",
        phone: "",
        job: "",
        sex: 1,
        deptId: "",
        roleId: "",
        birthDay: "",
        requestLeaveAnnual: "",
        remainLeaveAnnual: "",
      };
      this.getAllSysUser();
    },
    resetQparam() {
      this.qparam = {
        realName: "",
        phone: "",
        current: 1,
        size: 10,
      };
      this.getAllSysUser();
    },
    getAllSysRole() {
      requestRoleList().then((res) => {
        if (res.code === 200) {
          this.roleList = res.object;
        } else {
          this.$message.error("获取角色列表失败");
        }
      });
    },
    async getAnnualLeave(userId) {
      const res = await requestGetAnnualLeaveByUserId(userId)
      if (res.code === 200) {
        //已请年假
        this.requestLeaveAnnual = res.object.days;
        //剩余年假
        this.remainLeaveAnnual = this.totalLeaveAnnual - res.object.days;
        console.log('已请年假:',this.requestLeaveAnnual,"剩余年假:",this.remainLeaveAnnual)
        this.userForm.requestLeaveAnnual = this.requestLeaveAnnual;
        this.userForm.remainLeaveAnnual = this.remainLeaveAnnual;
        console.log('表单已请年假:',this.userForm.requestLeaveAnnual,"表单剩余年假:",this.userForm.remainLeaveAnnual)
      }
    },
  },
  created() {
    this.getAllSysRole();
    this.getAllSysUser();
  },
};
</script>

<style scoped></style>
